import ActivityChangeLocationNode from './ActivityChangeLocationNode';
import {connect} from '../../app/connect';
import {getLocationsTreeNodes, getIsLocationsLoadingError, getIsLocationsTreeLoading} from '../../app/selectors';

const mapStateToProps = state => ({
  isLocationsTreeLoading: getIsLocationsTreeLoading(state),
  isLocationsLoadingError: getIsLocationsLoadingError(state),
  locationsTreeNodes: getLocationsTreeNodes(state)
});

export default connect(mapStateToProps)(ActivityChangeLocationNode);
